"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
let Welcome = class extends Vue {
  constructor() {
    super(...arguments);
    this.platform = null;
    this.country = null;
    this.platform_list = [];
    this.counties_list = [];
    this.platform_step = 0;
    this.shop_id = null;
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.params.shop_id !== void 0) {
        this.shop_id = this.$route.params.shop_id;
      }
      let response = yield API.get(`api://base.auth/api/v7/orders/recomment/platform`);
      this.platform_list = response.data.datas;
      let _result = yield API.get(`api://base.auth/api/v7/orders/recomment/platform/country`);
      this.counties_list = _result.data.datas;
    });
  }
  choosePlatform() {
    return __async(this, null, function* () {
      if (this.platform !== null && this.platform !== "") {
        this.platform_step = 1;
      }
    });
  }
  chooseComplate() {
    return __async(this, null, function* () {
      if (this.country === null || this.country === "") {
        return;
      }
      let response = yield API.post(`api://base.auth/api/v7/orders/recomment/ipregion`, {
        "country_id": this.country,
        "platform_id": this.platform
      });
      if (this.shop_id === null) {
        this.$router.push({ name: "payment", query: { style: "create" }, params: {
          "type": "recommand"
        } });
      }
      if (this.shop_id !== null) {
        this.$router.push({ name: "payment", query: { style: "create" }, params: {
          "shop_id": this.shop_id,
          "type": "recommand"
        } });
      }
    });
  }
  toNew() {
    if (this.shop_id === null) {
      this.$router.push({ path: "/payment", query: { style: "create" } });
    }
    if (this.shop_id !== null) {
      this.$router.push({ name: "payment", query: { style: "create" }, params: {
        "shop_id": this.shop_id
      } });
    }
  }
  changePlatform() {
  }
  changeCountry() {
  }
};
Welcome = __decorateClass([
  Component
], Welcome);
export {
  Welcome as default
};
